"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, TypographyText } from "@workspace/frontend-ui";
import type { FC, MouseEvent } from "react";
import type { SelectedProvider } from "../../../types";
import EnabledProvidersBadges from "./EnabledProvidersBadges";

type Props = {
  enabledProviders: SelectedProvider[];
  onRemoveProvider: (provider: SelectedProvider) => void;
  onClearProviders: () => void;
};

const ProviderDropdownTriggerContent: FC<Props> = ({
  enabledProviders,
  onRemoveProvider,
  onClearProviders,
}) => {
  const handleClear = (event: MouseEvent) => {
    event.preventDefault();
    onClearProviders();
  };

  if (enabledProviders.length === 0) {
    return (
      <>
        <TypographyText variant="small">All providers</TypographyText>
        <div className="flex-1" />
      </>
    );
  }

  return (
    <>
      <EnabledProvidersBadges
        enabledProviders={enabledProviders}
        onRemoveProvider={onRemoveProvider}
      />
      <Button
        variant="secondary"
        className="rounded-full size-auto! size-6!"
        onClick={handleClear}
      >
        <HugeiconsIcon icon={Cancel01Icon} />
      </Button>
    </>
  );
};

export default ProviderDropdownTriggerContent;
